"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const helpers_1 = require("../../lib/helpers");
const Journey_1 = require("../../lib/Journey");
/** Simple spinner for loading page animation. */
const Spinner = (props) => {
    const primitiveProps = helpers_1.usePrimitiveProps(props);
    if (Journey_1.Journey.config.spinnerComponent) {
        const CustomSpinner = Journey_1.Journey.config.spinnerComponent;
        primitiveProps.className = primitiveProps.className.replace('j-spinner', '');
        return react_1.default.createElement(CustomSpinner, Object.assign({}, primitiveProps));
    }
    return (react_1.default.createElement("div", Object.assign({}, primitiveProps),
        react_1.default.createElement("svg", { viewBox: "0 0 24 24" },
            react_1.default.createElement("circle", { className: "opacity-25", cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "4" }),
            react_1.default.createElement("path", { className: "opacity-75", fill: "currentColor", d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" }))));
};
exports.default = withJourney_1.default('j-spinner', Spinner);
